document.addEventListener('DOMContentLoaded', () => {
  const nav = document.querySelector('.nav');
  const toggle = nav.querySelector('.btn-menu');
  const panel = nav.querySelector('#menu-panneau');
  const closeBtn = nav.querySelector('.btn-fermer');

  function openMenu () {
    nav.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
  }

  function closeMenu () {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    panel.setAttribute('hidden', '');
  }

  toggle.addEventListener('click', () => {
    const isOpen = nav.classList.contains('is-open');
    isOpen ? closeMenu() : openMenu();
  });

  closeBtn.addEventListener('click', closeMenu);

  // Clic hors du menu, ou sur le voile (pseudo-élément de .nav : la cible est .nav elle-même)
  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target) || e.target === nav) closeMenu();
  });

  // Échappe avec ÉCHAP
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });
});